export default {
  name: 'KyeAddressLabel',
  props: {
    value: [String],
    require: Boolean,
    labelWidth: {
      type: [Number, String],
    }
  },
  data() {
    return {
    }
  },
  render(h) {
    const { value, require, labelWidth } = this.$props
    const style = {
      width: labelWidth ? parseInt(labelWidth) + 'px' : 'auto'
    }
    const renderLabel = () => {
      return <div
        class={{ 'kye-address-label': true, 'kye-address-label-require': require }}
        style={style}
      >{value}</div>
    }
  const contentLabel = renderLabel()
  return contentLabel
  },
  methods: {
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-address/components/label.js